module.exports = __webpack_public_path__ + "media/images/green-web-foundation-a475f127dd164d4d9d27f280d608d878.png";